exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading-box[data-v-5868d9d2]{margin-top:200px}", ""]);

// exports
